const circulardocumenttype = {
    getlist: 'circulardocumenttype/getlist',
    add: 'circulardocumenttype/add',
    update: 'circulardocumenttype/update',
    remove: 'circulardocumenttype/remove',
    get: 'circulardocumenttype/get',
    getall: 'circulardocumenttype/getall',
    clearcache: 'circulardocumenttype/clear-cache',
}
export default circulardocumenttype
